import Vue from 'vue'
import Router from 'vue-router'
import sa from "../../static/js/lib/TCSensors.js"

Vue.use(Router)

// export default new Router({
let route = new Router({
  mode:'history',
  linkActiveClass:'is-active',
  routes: [
    {
      path: '/',
      name: 'index',
      component: ()=>import('../page/home/index'),
      meta:{isnavbar: true}
    },
    { // 条件选车
      path: '/m/home/xuanche',
      name: 'xuanche',
      component: ()=>import('../page/home/xuanche')
    },
    { // 买车
      path: '/m/home/buycar',
      name: 'buycar',
      component: ()=>import('../page/home/buycar'),
      meta:{isnavbar: true}
    },
    {
      path: '/m/home/newcar',//新车发布
      name: 'newCar',
      component: ()=>import('../page/home/newCar')
    },
    {
      path: '/m/home/pricereduction',//降价促销
      name: 'priceReduction',
      component: ()=>import('../page/home/priceReduction')
    },
    {
      path: '/m/home/salesort',//销量排行
      name: 'saleSort',
      component: ()=>import('../page/home/saleSort')
    },
    {
      path: '/m/dealer/index',
      name: 'index',
      component: ()=>import('../page/dealer/index'),
      meta:{isnavbar: true}
    },
    {
      path: '/m/dealer/promotiondetail',
      name: 'promotionDetail',
      component: ()=>import('../page/dealer/promotionDetail')
    },
    {
      path: '/m/activity/activityinfo',
      name: 'info',
      component: ()=>import('../page/activity/info')//活动详情 入参:id(场次id)
    },
    {
      path: '/m/activity/activityinfoTicket',
      name: 'infoTicket',
      component: ()=>import('../page/activity/infoTicket')//领票成功(已登录) 入参:id(场次活动id),token(this.cookie.getCookie("token"))
    },
    {
      path: '/m/activity/myTicket',
      name: 'myTicket',
      component: ()=>import('../page/activity/myTicket')//我的门票 入参:token(this.cookie.getCookie("token"))
    },
    {
      path: '/m/activity/tcjIntro',
      name: 'tcjIntro',
      component: ()=>import('../page/activity/tcjIntro')//团车节介绍
    },
    {
      path: '/m/activity/index',// 活动首页
      name: 'activityIndex',
      component: ()=>import('../page/activity/index'),
      meta:{isnavbar: true}
    },
    {//领票 和 报名
      path: '/m/activity/signup',//入参 groupbyNum场次id groupbyType活动类型
      name: 'signup',
      component: ()=>import('../page/activity/signup')
    },
    {
      path: '/m/home/finance', // 金融
      name: 'finance',
      component: ()=>import('../page/finance/index'),
      meta:{isnavbar: true}
    },
    {
      path: '/m/activity/list', // 活动列表
      name: 'activityList',
      component: ()=>import('../page/activity/list')
    },
    {
      path: '/m/privacyagreement',// 隐私协议
      name: 'privacy',
      component: ()=>import('../page/privacy/index')
    }
  ]
})

sa.init()
//vue 项目在路由切换的时候调用
route.afterEach((to,from) => {
  Vue.nextTick(() => {
    sa.pvtj();
  });
});

export default route



// WEBPACK FOOTER //
// ./src/router/index.js